import React from 'react';
import { Typography } from '@mui/material';
import useTimer from '@shared/hooks/userTimer';
import { formatTime } from '@shared/utils/FormatTime';

interface TimerProps {
  startTimestamp: Date | null;
}

const Timer: React.FC<TimerProps> = ({ startTimestamp }) => {
  const duration = useTimer(startTimestamp);

  return (
    <Typography color="text.secondary" fontWeight="600" fontSize="14px">
      {formatTime(duration)}
    </Typography>
  );
};

export default Timer;
